export const NOT_FOUND_DESCRIPTION =
  'The page you are looking for may have been moved, deleted or possibly never existed.';
export const SERVER_ERROR_DESCRIPTION =
  'Please refresh the page or try again later.';
export const UNAUTHORIZED_DESCRIPTION =
  'You can log in again to pick up where you left off.';
export const NOT_VERIFIED =
  'We send you an email. Please follow to the link to verify your account';
